import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { Toaster } from 'react-hot-toast';
import { queryClient } from '@/config/queryClient';
import { msalInstance } from '@/config/msalConfig';
import { ErrorBoundary } from './ErrorBoundary';
import { IdleTimeoutHandler } from './IdleTimeoutHandler';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <IdleTimeoutHandler />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={import.meta.env.BASE_URL}>
            {children}
            <Toaster position="top-center" />
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
}
